import { render } from "./GlossaryTopbar.vue?vue&type=template&id=1cc0eb86&scoped=true"
import script from "./GlossaryTopbar.vue?vue&type=script&lang=js"
export * from "./GlossaryTopbar.vue?vue&type=script&lang=js"

import "./GlossaryTopbar.vue?vue&type=style&index=0&id=1cc0eb86&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc0eb86"]])

export default __exports__